var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoImage = function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5m2.5 5h-5v-1h5zM4 17l4-5.96L10.48 13 13 9l1.853 2.964A6.44 6.44 0 0 0 13.026 17zm10.82 4H0V3h22v7.501a6.5 6.5 0 0 0-2-.476V5H2v14h11.502a6.5 6.5 0 0 0 1.318 2M5.5 10a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
  })));
};
export default SvgNoImage;